export interface AdSlot {
  /** Index into the RENDERED section list (displaySections), not the raw feed. */
  afterIndex: number;
  type: 'banner' | 'native';
}

/**
 * Ad placements, keyed on the index of a section that actually paints.
 *
 * These indices count `displaySections` — the feed ships many sections with an
 * empty `category_data`, and those still render a container. Keyed on the raw
 * index, slots landed inside invisible rows and stacked several ads on top of
 * each other. The spacing below assumes the filtered list.
 */
export const AD_SLOTS: AdSlot[] = [
  { afterIndex: 0, type: 'banner' },
  { afterIndex: 3, type: 'banner' },
  { afterIndex: 6, type: 'banner' },
  { afterIndex: 9, type: 'banner' },
  { afterIndex: 12, type: 'banner' },
  { afterIndex: 15, type: 'banner' },
  { afterIndex: 18, type: 'banner' },
  { afterIndex: 21, type: 'banner' },
  { afterIndex: 24, type: 'banner' },
  { afterIndex: 27, type: 'banner' },
  { afterIndex: 30, type: 'banner' },
  { afterIndex: 33, type: 'banner' },
];
